"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.department")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.department.accounting", {
            url: "/contabil"
        })
        .state("nucont.accounting.company.department.accounting.import", {
            url: "/importar",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentAccountingImportComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },

            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.accounting.scenarios", {
            url: "/cenarios/:scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true },
                source: { value: null, dynamic: true }
            },
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentAccountingScenariosComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        });
}
